// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vplus-widget{margin-left:0.5rem;margin-right:0.5rem;border-radius:0px !important}@media (min-width: 768px){.vplus-widget{margin-left:0px;margin-right:0px}}.vplus-widget a{font-family:Fira Sans Condensed, Rubik, Helvetica, Arial Narrow, Arial, sans-serif !important;line-height:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
